import { CONTACT_EMAIL } from "@/constants/contact";
import { cn } from "@/lib/utils";
import { Copy } from "lucide-react";
import { toast } from "sonner";

/** 문의 이메일 복사 버튼. 비보안 컨텍스트·권한 거부·포커스 없음으로 실패할 수 있어 토스트로 알린다 */
export const CopyEmailButton = ({ className }: { className?: string }) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(CONTACT_EMAIL);
      toast.success("이메일 주소가 복사되었습니다.");
    } catch {
      toast.error("이메일 주소를 복사하지 못했습니다. 직접 복사해주세요.");
    }
  };

  return (
    <button
      type="button"
      aria-label="이메일 주소 복사"
      className={cn("shrink-0", className)}
      onClick={handleCopy}
    >
      <Copy className="size-3.5" />
    </button>
  );
};
